import { render, staticRenderFns } from "./mtn.vue?vue&type=template&id=4013d036"
import script from "./mtn.vue?vue&type=script&lang=js"
export * from "./mtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports